var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      attrs: {
        showMask: true,
        title: _vm.$t("tradeMining.withdrawTitle"),
        closeIcon: true,
        close: _vm.close,
        rightBtnClick: _vm._cancelStake,
        rightBtnTxt: _vm.$t("tradeMining.withdrawBtn"),
        leftBtnClick: _vm.close,
        leftBtnTxt: _vm.$t("walletQuota.confirm.cancel.leftBtn")
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tradeMining.stakingBalance")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _c("img", {
            staticClass: "__icon",
            attrs: { src: _vm.viteTokenInfo ? _vm.viteTokenInfo.icon : "" }
          }),
          _vm._v("dSLS\n            "),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.stakingAmount))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint distance" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.withdrawHint1")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.withdrawHint2")))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }